import styled from 'styled-components'

export const H4 = styled.h4`
  font-weight: bold;
  font-size: 0.875em;
  line-height: 1.125em;
  color: ${({ theme }) => theme.darkGrey};
`
